import dayjs from 'dayjs';
import { join } from 'light-component';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import { Box } from '@common';
import * as Base from '@base';
import { Highlighter } from '../../component';
import styles from '../style.module.less';
import { service } from '../service';
import type { ReactElement } from 'react';
import type { CalendarProps } from './types';

dayjs.extend(weekday);
dayjs.extend(localeData);

export function CalendarInputMode(props: CalendarProps): ReactElement {
  return (
    <Box className={styles.inputBox} style={{ marginLeft: service.getIndent(props.path, 0.7) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          require={props.validator === 'required'}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={join(styles.action, styles.input)}>
        <Base.DatePicker
          disabled={props.readonly ?? false}
          className={styles.datePicker}
          // eslint-disable-next-line no-nested-ternary
          value={dayjs.isDayjs(props.value)
            ? props.value
            : (props.value != null ? dayjs(props.value) : undefined)}
          inputReadOnly
          onChange={date => props?.onPropsChange?.({ value: date == null ? null : dayjs(date) })}
          placeholder={props.textPlaceholder}
        />
      </Box>
    </Box>
  );
}
